// react
import { useEffect } from 'react';

// material-ui
import { Button, Stack, Tooltip, Box } from '@mui/material';

// project import
import MainCard from 'components/MainCard';

// assets

// ==============================|| DRAWER CONTENT - NAVIGATION CARD ||============================== //

const NavCard = () => {
  const version = process.env.REACT_APP_VERSION;
  const dayOfMonth = new Date().getDate();

  let env = process.env.REACT_APP_ENV?.toUpperCase();

  if (env === 'PRODUCTION') env = 'PROD';
  else if (env === 'LOCAL') env = 'LOCAL';
  else if (env === 'DEV') env = 'DEV';
  else env = 'QA';

  useEffect(() => {
    console.log('🙌 Price Lists Portal.  Version ', version);

    // Every hour, check to see if we passed midnight.  If so, refresh the site.
    const interval = setInterval(() => {
      console.log('  Version Check.  DOM', dayOfMonth);
      const currentDate = new Date();

      // check between midnight and 1
      if (currentDate.getDate() !== dayOfMonth && currentDate.getHours() < 1) {
        console.log('  Updating Site');
        window.location.reload();
      }
    }, 3600000);
    return (): void => clearInterval(interval);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MainCard sx={{ bgcolor: 'grey.50', m: 1 }}>
      <Stack alignItems="center" spacing={0.5}>
        <Tooltip title="Price Lists Portal Version.  Click to Update.">
          <Box>
            <Button id="refreshApplication" size="small" style={{ fontSize: '10px' }} onClick={(): void => window.location.reload()}>
              {env}-{version}
            </Button>
          </Box>
        </Tooltip>
      </Stack>
    </MainCard>
  );
};

export default NavCard;
